<template>
    <Button class="color-link" v-if="link" :type="color" link :hasIcon="hasIcon" :outlined="outlined">
        <AcfLink :data="link" />
    </Button>
</template>


<script>
import Button from '@/components/elements/Button'
import AcfLink from '@/components/elements/AcfLink'

export default {
    name: 'color-link',
    props: {
        link: Object,
        outlined: {
            type: Boolean,
            default: true
        },
        hasIcon: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'yellow'
        }
	},
    components:{
        Button,
        AcfLink
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.color-link{

}
</style>